exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-page[data-v-6c9ca486]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;height:100%;background:#f3f3f3;-webkit-box-sizing:border-box;box-sizing:border-box}.error-code[data-v-6c9ca486]{line-height:1;font-size:250px;font-weight:bolder;color:#2d8cf0}.error-code span[data-v-6c9ca486]{color:#00a854}.error-desc[data-v-6c9ca486]{font-size:30px;color:#777}.error-handle[data-v-6c9ca486]{margin-top:30px;padding-bottom:200px}.error-btn[data-v-6c9ca486]{margin-left:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c9ca486","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/404/index.vue
// module id = EQXP
// module chunks = 18